import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { API_BASE_URL_JSON } from '../../data-wp.service';


@Component({
    selector: 'app-darse-de-baja',
    templateUrl: './darse-de-baja.component.html',
    styleUrls: ['./darse-de-baja.component.css']
})
export class DarseDeBajaComponent implements OnInit {
    bajaForm: FormGroup;
    isSubmitting: boolean = false;
    isSubmitted: boolean = false;
    submitError: string = '';

    constructor(
        private fb: FormBuilder,
        private http: HttpClient,
        private router: Router
    ) {
        this.bajaForm = this.fb.group({
            nombre: ['', [Validators.required]],
            apellido: ['', [Validators.required]],            nro_socio: ['', [Validators.required]],
            telefono: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
            email: ['', [
                Validators.required,
                Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$")
            ]],
            comentario: ['']
        });
    }

    ngOnInit() {}    getEmailErrorMessage(): string {
        const emailControl = this.bajaForm.get('email');
        if (emailControl && emailControl.hasError('required')) {
            return 'El email es obligatorio';
        }
        if (emailControl && emailControl.hasError('pattern')) {
            return 'Por favor, ingrese un email válido';
        }
        return '';
    }

    onSubmit(): void {
        if (this.bajaForm.valid) {
            this.isSubmitting = true;
            this.submitError = '';

            const formData = new FormData();
            formData.append("nombre", this.bajaForm.get("nombre").value);
            formData.append("apellido", this.bajaForm.get("apellido").value);
            formData.append("socio", this.bajaForm.get("nro_socio").value);
            formData.append("telefono", this.bajaForm.get("telefono").value);
            formData.append("email", this.bajaForm.get("email").value);
            formData.append("comentario", this.bajaForm.get("comentario").value);

            const formId = '11220';

            this.http
                .post(`${API_BASE_URL_JSON}/contact-form-7/v1/contact-forms/${formId}/feedback`, formData)
                .subscribe(
                    (response: any) => {
                        if (response.status === 'mail_sent') {
                            this.isSubmitting = false;
                            this.isSubmitted = true;
                            this.bajaForm.reset();
                            const formElement = document.getElementById('formulario');
                            if (formElement) {
                                formElement.classList.add('enviado');
                            }

                            try {
                                this.router.navigate(['/gracias']);
                            } catch (e) {
                            }
                        } else {
                            this.isSubmitting = false;
                            this.submitError = 'Hubo un error al enviar el formulario. Por favor, intente nuevamente.';
                        }
                    },
                    (error) => {
                        this.isSubmitting = false;
                        this.submitError = 'Ocurrió un error al enviar el formulario. Por favor, intente nuevamente.';
                    }
                );        } else {
            Object.keys(this.bajaForm.controls).forEach(key => {
                const control = this.bajaForm.get(key);
                if (control && control.invalid) {
                    control.markAsTouched();
                }
            });
        }
    }
}